var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#C1D7EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2507 23.5H9.75065C8.82982 23.5 8.08398 22.7542 8.08398 21.8333V10.1667C8.08398 9.24583 8.82982 8.5 9.75065 8.5H22.2507C23.1715 8.5 23.9173 9.24583 23.9173 10.1667V21.8333C23.9173 22.7542 23.1715 23.5 22.2507 23.5Z",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 12.666V23.4993",
    stroke: "#001965",
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08398 12.6667H23.9173",
    stroke: "#001965",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5866 10.5746C10.5841 10.5746 10.5824 10.5763 10.5824 10.5788C10.5824 10.5813 10.5841 10.5829 10.5866 10.5829C10.5891 10.5829 10.5908 10.5813 10.5908 10.5788C10.5908 10.5763 10.5891 10.5746 10.5866 10.5746",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7057 10.5746C12.7032 10.5746 12.7016 10.5763 12.7016 10.5788C12.7016 10.5813 12.7032 10.5829 12.7057 10.5829C12.7082 10.5829 12.7099 10.5813 12.7099 10.5788C12.7099 10.5763 12.7082 10.5746 12.7057 10.5746",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8229 10.5746C14.8204 10.5746 14.8187 10.5763 14.8187 10.5788C14.8187 10.5813 14.8204 10.5829 14.8229 10.5829C14.8254 10.5829 14.8271 10.5813 14.8271 10.5788C14.8271 10.5763 14.8246 10.5746 14.8229 10.5746",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteVisit);
export default __webpack_public_path__ + "static/media/SiteVisit.0c27226bcdc0c646c58a6ce941719045.svg";
export { ForwardRef as ReactComponent };